import { useSearchParams } from "react-router-dom";

import { Pagination as MantinePagination } from "#shared/view/components/Pagination";

import classes from "./Pagination.module.css";

type Props = {
  totalItemsCount: number;
  itemsPerPage: number;
  queryParamName?: string;
};

export const Pagination = ({ totalItemsCount, itemsPerPage, queryParamName = "page" }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramInQuery = searchParams.get(queryParamName);
  const activePage = paramInQuery ? parseInt(paramInQuery) : 1;
  const numberOfPages = Math.ceil(totalItemsCount / itemsPerPage);
  const isPaginated = numberOfPages > 1;

  const setPage = (value: number) => {
    const params = new URLSearchParams(searchParams);
    params.set(queryParamName, value.toString());
    setSearchParams(params);
  };

  if (!isPaginated) {
    return null;
  }

  return (
    <MantinePagination
      total={numberOfPages}
      withEdges={false}
      autoContrast={true}
      withControls={false}
      value={activePage}
      onChange={setPage}
      color="white"
      className={classes.pagination}
    />
  );
};
